import { Box, Stack, Typography } from "@mui/material";
import Calendar from "components/Calendar";
import { TruncateTypography } from "components/TruncateTypography";
import { TasksQuery } from "generated-graphql/graphql";

import { calendarIconForTask, textColorForTask } from "./statusStyles";
import { buildBeforeAfterSearchString } from "./util.buildSearchString";

export const TasksCalendar = ({
  loading,
  tasks,
  onTaskClick,
  onRangeChange,
}: {
  loading: boolean;
  tasks: TasksQuery["virtualEvents"]["items"];
  onTaskClick: (task: TasksQuery["virtualEvents"]["items"][0]) => void;
  onRangeChange: (range: string) => void;
}) => {
  return (
    <Calendar
      sx={{ pb: 4 }}
      loading={loading}
      events={tasks}
      onEventClick={onTaskClick}
      onMonthChange={(month) => onRangeChange(buildBeforeAfterSearchString(month))}
      renderEventChip={(item, truncate = true) => {
        if (truncate) {
          return (
            <Stack
              sx={{ cursor: "pointer" }}
              direction="row"
              alignItems="center"
              spacing={0.5}
              overflow="hidden"
              onClick={() => onTaskClick(item)}
            >
              {calendarIconForTask(item)}
              <TruncateTypography variant="caption" color={textColorForTask(item)}>
                {item.title}
              </TruncateTypography>
            </Stack>
          );
        }
        return (
          <Stack
            sx={{ cursor: "pointer" }}
            direction="row"
            alignItems="center"
            spacing={0.5}
            onClick={() => onTaskClick(item)}
          >
            <Stack direction="row" height="100%">
              <Box sx={{ height: "1rem", marginTop: "-1px", marginRight: 0.5 }}>
                {calendarIconForTask(item)}
              </Box>
              <Typography variant="caption" color={textColorForTask(item)}>
                {item.title}
              </Typography>
            </Stack>
          </Stack>
        );
      }}
    />
  );
};
